// import { useState } from 'react';
import { useLanguageStore } from '../store/languageStore';
import { languageNames } from '../i18n';
import Logo from './Logo';
// import RulesModal from './RulesModal';

const Header = () => {
  const { language } = useLanguageStore();
  // const [showRules, setShowRules] = useState(false);

  return (
    <>
      <div className="bg-[#0a0a0a] border-b border-gray-800">
        <div className="flex items-center justify-between px-4 py-3">
          <Logo />
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <span className="px-2 py-1 text-xs text-primary font-semibold">
                {languageNames[language]}
              </span>
            </div>
            {/* <button
              onClick={() => setShowRules(true)}
              className="text-tg-hint hover:text-primary transition-colors p-1.5 rounded-lg hover:bg-gray-800/50"
              title="Rules"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </button> */}
          </div>
        </div>
      </div>
      {/* <RulesModal isOpen={showRules} onClose={() => setShowRules(false)} /> */}
    </>
  );
};

export default Header;

